/*
DoubleIncIndexedDB.js
双增公式的本地indexedDB
 */

import {INDEXED_DB_DOUBLE_INC_KEY} from "../../Common/constants";
import {initDB} from "../IndexedDB";

// 初始化所有卡片
export async function initDoubleIncCards(db) {
    // 获取所有卡片
    const cards = await db.getAll(INDEXED_DB_DOUBLE_INC_KEY);
    if (cards.length !== 4) {
        // 初始化卡片
        for (let i = 1; i <= 4; i++) {
            const card = {
                id: i,
                index: i,
                title: `卡片${i}`,
                description: '备注',
                T1: 't_{1}',
                T2: 't_{2}',
                k: 'K',
                cal: '-'
            }
            await db.put(INDEXED_DB_DOUBLE_INC_KEY, card);
        }
    }
}

// 获取所有卡片信息
export async function getAllCards() {
    const db = await initDB();
    const cards = await db.getAll(INDEXED_DB_DOUBLE_INC_KEY);
    return cards.sort((a, b) => a.index - b.index);
}

// 更新所有卡片的排序
export async function updateCardsIndex(cards) {
    const db = await initDB();
    for (let card of cards) {
        const stored_card = await db.get(INDEXED_DB_DOUBLE_INC_KEY, card.id);
        stored_card.index = card.index;
        await db.put(INDEXED_DB_DOUBLE_INC_KEY, stored_card);
    }
}

// 获取单个卡片
export async function getDoubleIncCard(id) {
    const db = await initDB();
    return await db.get(INDEXED_DB_DOUBLE_INC_KEY, id);
}

// 更新卡片的信息
export async function updateDoubleCardInfo(id, title, description, T1, T2, k, cal) {
    const db = await initDB();
    const card = await db.get(INDEXED_DB_DOUBLE_INC_KEY, id);
    card.title = title;
    card.description = description;
    card.T1 = T1;
    card.T2 = T2;
    card.k = k;
    card.cal = cal;
    await db.put(INDEXED_DB_DOUBLE_INC_KEY, card);
}